import SuccessView from "../../../common/success";
import ViewFactory from "../../../helpers/viewfactory";

export default function view() {
  const $this = this;
  const { $charge, $timer } = this;
  
  const pollConfig = {
    onBegin() { $this.CAN_GO_BACK = false, $timer.start()},
    onCancel() { pollConfig.onComplete() },
    onSuccessful() { SuccessView && SuccessView.activate.call($this) },
    onComplete() { /* self.console.log({ ...$this }) */ $this.CAN_GO_BACK = true, $timer.clear(), $this.QR_CODE = null }
  }

  return (view = ViewFactory({
    NAME: 'ENAIRA_QR_VIEW',
    mutables: { hasBackAction: 'CAN_GO_BACK', timerCurrent: 'CURRENT_TIME' },
    constants: {
      get qrcode() { return $this.QR_CODE },
      instruction: 'Scan the QR Code below on your eNaira mobile app to complete the payment',
      resetView() {
        $charge.cancel();
        $this.cancelOption();
      }
    },
    next() {
      $charge.poll(pollConfig);
    },
    back() { $this.CAN_GO_BACK && $this.INIT_VIEW() }
  }).call(this));
}
